import { MembersTableColumnField } from "@components/table/members/members-table-types";

/** All available column fields for the members table */
export const MEMBERS_TABLE_COLUMNS = [
  "name",
  "user",
  "email",
  "status",
  "role",
  "joinedDate",
  "options",
] as const;

/**
 * Members table columns without the "name" column.
 * Useful for tables where member identity is shown via the "user" column instead.
 */
export const WORKSPACE_MEMBERS_TABLE_COLUMNS = MEMBERS_TABLE_COLUMNS.filter(
  (col) => col !== "name" && col !== "joinedDate"
);

/** The labels for the columns in the members table */
export const MEMBERS_TABLE_COLUMN_LABELS: Record<
  MembersTableColumnField,
  string
> = {
  name: "Name",
  user: "User",
  email: "Email",
  status: "Status",
  role: "Role",
  joinedDate: "Added date",
  options: "Options",
};

/** Sortable column fields for the members table */
export const MEMBERS_SORTABLE_FIELDS = [
  "user",
  "name",
  "email",
  "status",
  "role",
  "joinedDate",
] as const;

/** The labels for the sortable members columns */
export type MembersSortField = (typeof MEMBERS_SORTABLE_FIELDS)[number];

/** The labels for the sortable members columns */
export const MEMBERS_SORT_COLUMN_LABELS: Record<MembersSortField, string> = {
  user: "User",
  name: "Name",
  email: "Email",
  status: "Status",
  role: "Role",
  joinedDate: "Added date",
};

/**
 * Team members table columns without the "name" column.
 * Useful for tables where member identity is shown via the "user" column instead.
 */
export const TEAM_MEMBERS_TABLE_COLUMNS = MEMBERS_TABLE_COLUMNS.filter(
  (col) => col !== "name"
);
